import { CartScreen } from 'features/cart/cart-screen';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { Cart } from 'pages/cart/cart';

export default function CartPage() {
  useExposeMinimalCartExperiment();
  const enableMinimalCartUI = useMinimalCartUi();
  if (enableMinimalCartUI) {
    return <CartScreen />;
  }
  return <Cart />;
}
